export enum UserTimelineTypeEnum {
  TASK = "task",
  SPIKE = "spike",
  EVENT = "event",
  OFFTIME = "offtime",
}
